<template>
  <span>
    <slot
      :confirm="didOpen"
    ></slot>
    <portal to="modals">
      <div
        class="z-50 fixed w-full h-full top-0 flex items-center bg-black-opacity-50"
        v-show="confirmationModalOpen"
        @click="didCancel"
        @keyup.escape="didCancel"
      >
        <div class="rounded shadow-lg max-w-lg bg-white mx-auto mt-16 p-8" @click.stop>
          <div class="text-center mb-4 text-2xl font-bold">Are you sure?</div>
          <div class="text-center text-gray-600er mb-6">
            Deleting this Grade Level cannot be undone.
            <br/>
            Students in the grade level will remain, just without a grade level.
          </div>
          <div class="flex justify-around">
            <button class="py-2 px-4 rounded cursor-pointer text-center whitespace-nowrap border-gray-300 border-2" @click="didCancel">Cancel</button>
            <button class="text-white py-2 px-4 rounded cursor-pointer bg-red-600 hover:bg-red-700 text-center whitespace-nowrap" @click="didConfirm">Delete it</button>
          </div>
        </div>
      </div>
    </portal>
  </span>
</template>

<script>
import gql from 'graphql-tag'

export default {
  props: {
    gradeLevelId: {
      required: true
    },
    refetch: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      confirmationModalOpen: false
    }
  },

  methods: {
    didOpen () {
      this.confirmationModalOpen = true
    },

    didConfirm () {

      this.$apollo.mutate({
        mutation: gql`
          mutation ($id: ID!) {
            gradeLevelDelete (id: $id) {
              id
            }
          }`,
        variables: {
          id: this.gradeLevelId,
        },
        refetchQueries: this.refetch
      })
      .then((data) => {
        console.log('Cardstock: DeleteGradeLevelConfirmation - Successful GradeLevelDelete')
        this.$router.push({name: 'gradeLevels'})
        this.confirmationModalOpen = false
      })
      .catch((error) => {
        console.error('Cardstock: DeleteGradeLevelConfirmation - Error GradeLevelDelete ' + error)
      })
    },

    didCancel () {
      this.confirmationModalOpen = false
    }
  },

  watch: {
    confirmationModalOpen: {
      immediate: true,
      handler: show => {
        if (show) {
          document.body.style.setProperty("overflow", "hidden")
        } else {
          document.body.style.removeProperty("overflow")
        }
      }
    }
  },
}
</script>
